export default "__VITE_ASSET__UkALYOLy__"